import { useGetLoggedInUser } from "./vegApl"

const useGetCurrentUser = (emailId: string) => {
    const { data, ...rest } = useGetLoggedInUser(emailId, {
        query: {
            queryKey: ["email", emailId],
            select: (d) => {
                const rows: any = d?.data ?? [];
                const roleNames:any = [
                    ...new Set(
                        rows?.user_roles?.flatMap((module: any) =>
                            module?.roles?.map((role: any) => role?.role_name)
                        )
                    )
                ]


                const uniqueSites =
                    Array.from(
                        new Set(
                            rows?.user_roles?.flatMap((ur: any) =>
                                (ur.roles ?? []).flatMap((r: any) => r?.sites ?? [])
                            )
                        )
                    );
                const isAdmin = roleNames?.some((role: string) => role?.toLowerCase() == "admin") ?? false;
                const isTechnician = roleNames?.some((role: string) => role?.toLowerCase() == "technician") ?? false;
                let obj = {
                    user_name: rows?.user_name,
                    user_email: rows?.user_email,
                    is_user_admin: isAdmin,
                    userRoles: roleNames,
                    siteNames: uniqueSites,
                    isTechnician: isTechnician,
                    user_id: rows?.user_id

                }              
                return obj;

            },
            refetchOnWindowFocus: false,
            enabled: Boolean(emailId),
        },
    })

    return { data, ...rest }
}

export default useGetCurrentUser
